import type {SVGProps} from "react";

export const TotalBrandGiftCardsIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}
    >
        <g clipPath="url(#total-brand-gift-cards-clip)">
            <path
                d="M14.1914 3.48535H3.35807C2.61019 3.48535 2.00391 4.09163 2.00391 4.83952V11.6104C2.00391 12.3582 2.61019 12.9645 3.35807 12.9645H14.1914C14.9393 12.9645 15.5456 12.3582 15.5456 11.6104V4.83952C15.5456 4.09163 14.9393 3.48535 14.1914 3.48535Z"
                stroke="#00C49A"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.00391 6.87085H15.5456"
                stroke="#00C49A"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="total-brand-gift-cards-clip">
                <rect width="16.25" height="16.25" fill="white" transform="translate(0.649414 0.0999756)" />
            </clipPath>
        </defs>
    </svg>
);
